const config = {
  title: [
    {
      className: 'dti-details-title-primary',
      label:
        'Your debt-to-income ratio (DTI) would be {{0}}, meaning {{1}} of your pretax income would go toward mortgage and other debts.',
      viewType: 'text',
      keys: [
        {
          type: 'percent',
          formatterStr: '0%',
          key: 'adjustedOutputs.dti',
        },
        {
          type: 'percent',
          formatterStr: '0%',
          key: 'adjustedOutputs.dti',
        },
      ],
    },
    {
      className: 'dti-details-title-secondary',
      title: 'Monthly income',
      label: '{{0}}',
      viewType: 'text',
      keys: [
        {
          type: 'currency',
          key: 'adjustedOutputs.monthlyBudget.monthlyIncome',
        },
      ],
    },
  ],
  items: [
    {
      title: {
        label: 'Housing ({{0}} of pretax income)',
        viewType: 'text',
        keys: [
          {
            type: 'percent',
            formatterStr: '0%',
            key: 'adjustedOutputs.monthlyBudget.housingToIncome',
          },
        ],
      },
      value: {
        label: '{{0}}',
        value: '{{0}}',
        delta: '{{1}}',
        deltaLabel: '{{2}}',
        viewType: 'text',
        keys: [
          {
            type: 'currency',
            key: 'adjustedOutputs.monthlyPayments.total',
          },
          {
            type: 'currency',
            key: 'delta.monthlyBudget.housing',
          },
          {
            type: 'percent',
            formatterStr: '0%',
            key: 'delta.monthlyBudget.housingToIncome',
          },
        ],
      },
    },
    {
      title: {
        label: 'Debts ({{0}} of pretax income)',
        value: '{{0}}',
        viewType: 'text',
        keys: [
          {
            type: 'percent',
            formatterStr: '0%',
            key: 'adjustedOutputs.monthlyBudget.debtToIncome',
          },
        ],
      },
      value: {
        label: '{{0}}',
        value: '{{0}}',
        viewType: 'text',
        keys: [
          {
            type: 'currency',
            key: 'inputs.monthlyDebt',
          },
        ],
      },
    },
    {
      title: {
        label: 'Expenses & savings ({{0}} of pretax income)',
        viewType: 'text',
        keys: [
          {
            type: 'percent',
            formatterStr: '0%',
            key: 'adjustedOutputs.monthlyBudget.restToIncome',
          },
        ],
      },
      value: {
        label: '{{0}}',
        value: '{{0}}',
        delta: '{{1}}',
        deltaLabel: '{{2}}',
        viewType: 'text',
        keys: [
          {
            type: 'currency',
            key: 'adjustedOutputs.monthlyBudget.rest',
          },
          {
            type: 'currency',
            key: 'delta.monthlyBudget.rest',
          },
          {
            type: 'percent',
            formatterStr: '0%',
            key: 'delta.monthlyBudget.restToIncome',
          },
        ],
      },
    },
    {
      title: {
        label: 'Taxes ({{0}} of pretax income)',
        viewType: 'text',
        keys: [
          {
            type: 'percent',
            formatterStr: '0%',
            key: 'adjustedOutputs.monthlyBudget.taxesToIncome',
          },
        ],
      },
      value: {
        label: '{{0}}',
        value: '{{0}}',
        viewType: 'text',
        keys: [
          {
            type: 'currency',
            key: 'adjustedOutputs.monthlyBudget.taxes',
          },
        ],
      },
    },
  ],
};

export default config;
